import React from 'react';
import { FormattedMessage } from 'react-intl';
import PositiveToast from '@/components/toasts/PositiveToast';
import CollectionDatasetAssignToast from './CollectionDatasetAssignToast';

const CollectionDatasetsAssignToast = ({ name, datasets }) => {
  if (datasets.length === 1) {
    return (<CollectionDatasetAssignToast name={name} />);
  }

  return (
    <PositiveToast className="aridhia-collection-datasets-assigned-toast">
      <FormattedMessage id="toast.collection.datasets" values={{ name, count: datasets.length }} />
    </PositiveToast>
  );
};

export default CollectionDatasetsAssignToast;
